import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=f2d65afe&scoped=true"
import script from "./Errors.vue?vue&type=script&lang=js"
export * from "./Errors.vue?vue&type=script&lang=js"
import style0 from "./Errors.vue?vue&type=style&index=0&id=f2d65afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d65afe",
  null
  
)

export default component.exports